<template>
  <div
    class="w-full mb-10"
    :class="{
      'pl-[20%]': isOwn,
      'pr-[20%]': !isOwn
    }"
  >
    <div
      class="p-4 rounded-md"
      :class="{
        'bg-primary-100': isOwn,
        'bg-gray-100': !isOwn
      }"
    >
      <div class="flex items-center gap-x-4">
        <div class="text-sm font-medium text-gray-900">
          {{ comment.from || 'You' }}
        </div>
        <div class="text-xs text-gray-500 text-light ml-auto">
          {{ comment.createdAt }}
        </div>
        <template v-if="isOwn">
          <button class="inline-block text-primary-500 hover:text-primary-600" @click.stop.prevent="onEdit">
            <PencilOutline class="h-6 w-6" aria-hidden="true" />
          </button>
          <button class="inline-blockt text-primary-500 hover:text-primary-600" @click.stop.prevent="onDeleted">
            <TrashCanOutline class="h-6 w-6" aria-hidden="true" />
          </button>
        </template>
      </div>
      <div class="text-sm text-gray-500 my-4">
        {{ comment.text }}
      </div>
      <div v-if="comment.files?.length" class="flex flex-wrap gap-4">
        <a v-for="(file, key) in comment.files" :key="key" :href="file.id" target="_blank">
          <item-file :file="file" />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ItemFile from './ItemFile.vue';
import TrashCanOutline from 'vue-material-design-icons/TrashCanOutline.vue';
import PencilOutline from 'vue-material-design-icons/PencilOutline.vue';
import { Modal } from '../composables/useModal';

const props = defineProps({
  comment: {
    type: Object,
    default: () => {}
  }
});

const emit = defineEmits([ 'delete', 'edit' ]);

const isOwn = computed(() => props.comment.from !== null); // FIXME: get user ID from store or context

async function onDeleted() {
  const confirm = await Modal.confirm({
    title: 'Delete comment',
    body: 'Are you sure you want to delete this comment?',
    okButton: 'Delete',
    cancelButton: 'Cancel'
  });

  if (!confirm) {
    return;
  }

  emit('delete', props.comment.id);
}

function onEdit() {
  emit('edit', props.comment.id);
}
</script>
